import React, { useState, useEffect } from 'react';
import downArrow from "../assets/downArrow.png";
import currentRateIcon from '../assets/currentRateIcon.png'
import Navbar from "./Navbar";
import xbox2 from "../assets/xbox2.png";
import ps2 from "../assets/ps2.png";
import origin2 from "../assets/origin2.png";
import bulb from "../assets/bulb.png";
import req from "../assets/req.png";
import api from '../utils/api';
import Logo from "../assets/layer1 copy.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";


import { Link } from "react-router-dom";


const SellCoins = () => {
  const [platform, setPlatform] = useState("XB"); // Default platform
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [tempPayPalEmail, setTempPayPalEmail] = useState("");

  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [amount, setAmount] = useState(0); // Amount entered
  const [income, setIncome] = useState(0); // Calculated income

  const [selectedMethod, setSelectedMethod] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    contactEmail: "",
    originEmail: "",
    originPassword: "",
    backupCode1: "",
    backupCode2: "",
    paymentMethod: "",
    paypalEmail: "",
    agreedToTerms: false,
  });


  const handleChange = (e) => {
    const method = e.target.value;
    setSelectedMethod(method);
    if (method === "PayPal") {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  };

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await api.get('https://fcs-backend-production.up.railway.app/api/sell-prices');
        setPrices(response.data.data); // Assuming the prices are returned under `data`
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();
  }, []);

  useEffect(() => {
    if (prices.length > 0 && amount > 0) {
      const selectedPrice =
        platform === "XB" ? prices[0].XB : platform === "PS" ? prices[0].PS : prices[0].PC;
      const incomePer100k = amount / 100; // Calculate units of 100k
      setIncome(incomePer100k * selectedPrice * 0.98); // Multiply by price per 100k
    } else {
      setIncome(0); // Reset income if amount or prices are invalid
    }
  }, [platform, amount, prices]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loading animation

    // Prepare data for API
    const dataToSend = {
      platform,
      totalCoins: amount,
      coinsPrice: income,
      contactEmail: formData.contactEmail,
      originEmail: formData.originEmail,
      originPassword: formData.originPassword,
      backupCode1: formData.backupCode1,
      backupCode2: formData.backupCode2,
      paymentMethod: formData.paymentMethod,
      paypalEmail: formData.paypalEmail,
      agreedToTerms: formData.agreedToTerms,
    };

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/sell-coins`,
        dataToSend
      );

      // Show success toast
      toast.success("Sell order placed successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Reset form after successful submission
      setFormData({
        contactEmail: "",
        originEmail: "",
        originPassword: "",
        backupCode1: "",
        backupCode2: "",
        paymentMethod: "",
        paypalEmail: "",
        agreedToTerms: false,
      });
      setAmount(0);
      setIncome(0);

    } catch (err) {
      // Show error toast
      toast.error("Failed to place sell order. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false); // Hide loading animation
    }
  };

  // Handle input changes for dynamic fields
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };



  return (
    <>
      {/* <Navbar /> */}
      <ToastContainer />
      <section className="min-h-screen lg:bg-bg-[#191919]  bg-[#191919]  text-white font-inter px-6 lg:px-8 overflow-x-hidden">

        {/* Back Button */}
        <Link to="/" className="text-primary font-bold flex items-center mb-6">
          <i className="fas fa-arrow-left mr-2"></i> Back
        </Link>

        {/* Page Title */}
        <div className="text-center mb-10">
          <h1
            className="text-3xl md:text-6xl lg:text-5xl font-monument font-extrabold text-primary text-center"
            style={{ fontFamily: "", fontWeight: 800 }}
          >
            SELL COINS
          </h1>          <div className="flex justify-center">
            <img src={downArrow} alt="Arrow Down" className="h-6 md:h-8 mt-4" />          </div>
        </div>


        {/* Current Rate Section */}
        <div className="mt-10 bg-[#1A1A1A] border border-gray-600 rounded-xl p-6 text-center  mb-8 sm:mx-8 lg:mx-24">
          <div className="flex flex-col items-center">
            <img
              src={currentRateIcon}
              alt="Current Rate Icon"
              className="w-12 h-12 mb-2"
            />
            <h2 className="text-lg font-bold text-primary">Current Rate</h2>
          </div>
          <div className="flex flex-col sm:flex-row justify-center items-center mt-4 space-y-4 sm:space-y-0 sm:space-x-6">
            {/* Xbox/PS Rate */}
            <div className="text-sm text-center">
              <p className="font-bold text-primary">Xbox/PS</p>
              <span>
                {prices.length > 0 ? (
                  `$${prices[0].PS.toFixed(2)} USD/100k ≈ £${(prices[0].PS * 0.77).toFixed(
                    2
                  )}/100k ≈ €${(prices[0].PS * 0.93).toFixed(2)}/100k`
                ) : (
                  "Loading..."
                )}
              </span>
            </div>
            {/* PC Rate */}
            <div className="text-sm text-center">
              <p className="font-bold text-primary">PC</p>
              <span>
                {prices.length > 0 ? (
                  `$${prices[0].PC.toFixed(2)} USD/100k ≈ £${(prices[0].PC * 0.77).toFixed(
                    2
                  )}/100k ≈ €${(prices[0].PC * 0.93).toFixed(2)}/100k`
                ) : (
                  "Loading..."
                )}
              </span>
            </div>
          </div>

        </div>

        <div className="bg-[#1A1A1A] border mb-5 mt-5 border-gray-600 rounded-lg p-6 text-center lg:hidden">
          {/* How It Works Section */}
          <div className="mb-8">
            <img src={bulb} alt="How It Works" className="w-10 h-10 mx-auto mb-4" />
            <h3 className="text-primary text-lg font-bold mb-4">How It Works?</h3>
            <ul className="text-sm text-white space-y-2 text-left">
              <li>1. Fill out the form, and we’ll take care of everything else.</li>
              <li>2. The coin selling and payment process usually takes 24 hours.</li>
              <li>3. Stay offline on your console and apps during this process.</li>
              <li>4. Payment is sent within 24 hours after the coins are transferred.</li>
            </ul>
          </div>

          {/* Requirements Section */}
          <div>
            <img src={req} alt="Requirements" className="w-10 h-10 mx-auto mb-4" />
            <h3 className="text-primary text-lg font-bold mb-4">Requirements</h3>
            <ul className="text-sm text-white space-y-2 text-left">
              <li>• Web App Transfer Market must be unlocked.</li>
              <li>• Minimum of 500k (500,000) coins.</li>
              <li>• Fewer than 5 unassigned items.</li>
              <li>• Must stay offline on console, web app, and companion app.</li>
            </ul>
          </div>
        </div>

        {/* Main Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8  sm:px-6 lg:px-20">
          {/* Left Section */}
          <div className=" lg:col-span-2 bg-[#1A1A1A] border border-gray-600 rounded-lg p-6 ">
            {/* Platform Selection */}
            <div className="lg:flex justify-center flex-wrap space-x-2 mb-6 hidden">
              <button
                className={`px-6 py-2 w-44 rounded-lg font-bold flex items-center space-x-2 border mb-2 lg:mb-0 ${platform === "XB"
                  ? "bg-primary text-black border-transparent"
                  : "bg-[#1A1A1A] text-primary border-primary"
                  }`}
                onClick={() => setPlatform("XB")}
              >
                <img
                  src={xbox2}
                  alt="Xbox Icon"
                  className={`w-5 h-5 ${platform !== "XB" ? "filter invert brightness-200" : ""}`}
                />
                <span>Xbox Coins</span>
              </button>

              <button
                className={`px-6 py-2 rounded-lg w-44 font-bold flex hover:bg-primary hover:text-black mb-3 mt-2 lg:mt-0 lg:mb-0 items-center space-x-2 border ${platform === "PS"
                  ? "bg-primary text-black border-transparent"
                  : "bg-[#1A1A1A] text-primary border-primary"
                  }`}
                onClick={() => setPlatform("PS")}
              >
                <img src={ps2} alt="PS Icon" className="w-5 h-5" />
                <span>PS Coins</span>
              </button>
              <button
                className={`px-6 py-2 rounded-lg w-44 font-bold flex mb-3 mt-1 lg:mt-0 lg:mb-0 items-center hover:bg-primary hover:text-black space-x-2 border ${platform === "PC"
                  ? "bg-primary text-black border-transparent"
                  : "bg-[#1A1A1A] text-primary border-primary"
                  }`}
                onClick={() => setPlatform("PC")}
              >
                <img src={origin2} alt="PC Icon" className="w-5 h-5" />
                <span>PC Coins</span>
              </button>
            </div>

            <div className="flex flex-col sm:flex-row sm:flex-wrap sm:space-x-2 space-y-2 sm:space-y-0 mb-6 lg:hidden">
              {/* Xbox Button */}
              <button
                className={`px-6 py-2  w-44 ml-16 mt-2 rounded-lg font-bold flex items-center justify-center sm:justify-start space-x-2 border ${platform === "XB"
                    ? "bg-primary text-black border-transparent"
                    : "bg-[#1A1A1A] text-primary border-primary"
                  }`}
                onClick={() => setPlatform("XB")}
              >
                <img
                  src={xbox2}
                  alt="Xbox Icon"
                  className={`w-5 h-5 ${platform !== "XB" ? "filter invert brightness-200" : ""
                    }`}
                />
                <span>Xbox Coins</span>
              </button>

              {/* PS Button */}
              <button
                className={`px-6 py-2  w-44 ml-16 mt-2 rounded-lg font-bold flex items-center justify-center sm:justify-start space-x-2 border ${platform === "PS"
                    ? "bg-primary text-black border-transparent"
                    : "bg-[#1A1A1A] text-primary border-primary"
                  }`}
                onClick={() => setPlatform("PS")}
              >
                <img src={ps2} alt="PS Icon" className="w-5 h-5" />
                <span>PS Coins</span>
              </button>

              {/* PC Button */}
              <button
                className={`px-6 py-2 ml-16 mt-2 w-44 rounded-lg font-bold flex items-center justify-center sm:justify-start space-x-2 border ${platform === "PC"
                    ? "bg-primary text-black border-transparent"
                    : "bg-[#1A1A1A] text-primary border-primary"
                  }`}
                onClick={() => setPlatform("PC")}
              >
                <img src={origin2} alt="PC Icon" className="w-5 h-5" />
                <span>PC Coins</span>
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Amount of Coins to Sell */}
                <div>
                  <label className="block text-sm font-medium mt-4 text-white mb-1">
                    Amount of Coins to Sell (K's)
                    <span className="relative group ml-2">
                      {/* Info Icon */}
                      <i
                        className="fas fa-info-circle text-primary cursor-pointer"
                        title="Click for info"
                      ></i>
                      {/* Tooltip */}
                      <span className="absolute left-0 mt-2 w-64 bg-black text-white text-xs rounded-lg p-2 shadow-lg opacity-0 group-hover:opacity-100 group-hover:translate-y-1 transition-all duration-300 z-10">
                        1000K = 1 million coins
                      </span>
                    </span>
                  </label>
                  <input
                    type="number"
                    min="50"
                    value={amount}
                    onChange={(e) => setAmount(parseInt(e.target.value))}
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none focus:ring focus:ring-primary"
                  />
                </div>

                {/* Your Income */}
                <div>
                  <label className="block text-sm font-medium mt-1 text-white mb-1">Estimated Income ≈</label>
                  <input
                    type="text"
                    value={`$${income.toFixed(2)}`}
                    readOnly
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none"
                  />
                </div>

                {/* Contact Email */}
                <div>
                  <label className="block text-sm font-medium mt-1 text-white mb-1">Contact Email</label>
                  <input
                    type="email"
                    name="contactEmail"
                    value={formData.contactEmail}
                    onChange={handleInputChange}
                    placeholder="Enter contact email"
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none"
                  />
                </div>

                {/* WebApp Email */}
                <div>
                  <label className="block text-sm font-medium text-white mt-1 mb-1 flex items-center">
                    WebApp Email
                    <button
                      className="text-primary ml-2 relative group"
                      aria-label="Info"
                    >
                      <i className="fas fa-info-circle"></i>
                      <div className="absolute left-0 mt-1 w-48 bg-primary text-black text-xs rounded-lg p-2 hidden group-hover:block z-10">
                        This can be found in the FC25 settings menu or on EA.com.
                      </div>
                    </button>
                  </label>
                  <input
                    type="email"
                    name="originEmail"
                    value={formData.originEmail}
                    onChange={handleInputChange}
                    placeholder="Enter WebApp email"
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none focus:ring focus:ring-primary"
                  />
                </div>

                {/* WebApp Password */}
                <div>
                  <label className="block text-sm font-medium text-white mt-1 mb-1 flex items-center">
                    WebApp Password
                    <button
                      className="text-primary ml-2 relative group"
                      aria-label="Info"
                    >
                      <i className="fas fa-info-circle"></i>
                      <div className="absolute left-0 mt-1 w-48 bg-primary text-black text-xs rounded-lg p-2 hidden group-hover:block z-10">
                        Use your EA email to find your password on EA.com.
                      </div>
                    </button>
                  </label>
                  <input
                    type="password"
                    name="originPassword"
                    value={formData.originPassword}
                    onChange={handleInputChange}
                    placeholder="Enter password"
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none focus:ring focus:ring-primary"
                  />
                </div>

                {/* Backup Code 1 */}
                <div>
                  <label className="block text-sm font-medium text-white mt-1 mb-1 flex items-center">
                    Backup Code 1
                    <button
                      className="text-primary ml-2 relative group"
                      aria-label="Info"
                    >
                      <i className="fas fa-info-circle"></i>
                      <div className="absolute left-0 mt-1 w-48 bg-primary text-black text-xs rounded-lg p-2 hidden group-hover:block z-10">
                        Backup codes allow us to bypass your account's login verification code.
                        Please always refresh your backup codes before submitting one.
                      </div>
                    </button>
                  </label>
                  <input
                    type="text"
                    name="backupCode1"
                    value={formData.backupCode1}
                    onChange={handleInputChange}
                    placeholder="Enter Backup Code 1"
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none focus:ring focus:ring-primary"
                  />
                </div>

                {/* Backup Code 2 */}
                <div>
                  <label className="block text-sm font-medium text-white mt-1 mb-1 flex items-center">
                    Backup Code 2
                    <button
                      className="text-primary ml-2 relative group"
                      aria-label="Info"
                    >
                      <i className="fas fa-info-circle"></i>
                      <div className="absolute left-0 mt-1 w-48 bg-primary text-black text-xs rounded-lg p-2 hidden group-hover:block z-10">
                        Backup codes allow us to bypass your account's login verification code.
                        Please always refresh your backup codes before submitting one.
                      </div>
                    </button>
                  </label>
                  <input
                    type="text"
                    name="backupCode2"
                    value={formData.backupCode2}
                    onChange={handleInputChange}
                    placeholder="Enter Backup Code 2"
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none focus:ring focus:ring-primary"
                  />
                </div>

                {/* Payment Method */}
                {/* Payment Method */}
                <div>
                  <label className="block text-sm font-medium text-white mb-2 mt-1">
                    Payment Method
                  </label>
                  <select
                    name="paymentMethod"
                    value={formData.paymentMethod}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({
                        ...formData,
                        paymentMethod: value,
                      });
                      if (value === "PayPal") {
                        setShowPopup(true); // Show popup for PayPal email input
                      }
                    }}
                    className="bg-black border border-primary w-full rounded-lg px-4 py-2 text-white focus:outline-none focus:ring focus:ring-primary appearance-none"
                  >
                    <option value="">Select a method</option>
                    <option value="PayPal">PayPal</option>
                    {/* Uncomment these if you want additional payment methods */}
                    {/* <option value="Bank Transfer">Bank Transfer US</option>
    <option value="Bank Transfer International">Bank Transfer International</option> */}
                  </select>

                  {showPopup && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                      <div className="bg-black rounded-lg p-6 text-center w-11/12 max-w-md relative">
                        {/* Close Button */}
                        <button
                          className="absolute top-3 right-3 text-primary font-bold text-lg hover:text-white"
                          onClick={() => setShowPopup(false)}
                        >
                          ✕
                        </button>

                        {/* Logo */}
                        <img src={Logo} alt="Logo" className="mx-auto w-16 mb-4" />
                        <h2 className="text-primary font-bold mb-2">PayPal Email</h2>
                        <p className="text-sm text-gray-600 mb-4">Please enter payment details</p>

                        {/* Email Input */}
                        <input
                          type="email"
                          value={tempPayPalEmail} // Temporary state for PayPal email
                          onChange={(e) => setTempPayPalEmail(e.target.value)}
                          placeholder="Enter PayPal Email"
                          className="w-full border text-black border-gray-400 rounded-lg px-4 py-2 mb-4 focus:outline-none"
                        />

                        {/* Save Button */}
                        <button
                          className="w-full bg-primary text-black font-bold py-2 rounded-lg hover:bg-yellow-400"
                          onClick={() => {
                            setFormData({
                              ...formData,
                              paypalEmail: tempPayPalEmail, // Save the email temporarily in formData
                            });
                            setShowPopup(false); // Close the popup
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  )}
                </div>



                {/* Other Fields */}
                {/* Add similar inputs for originEmail, originPassword, backupCode1, backupCode2, paymentMethod, and paypalEmail */}
              </div>

              {/* Terms and Conditions */}
              <div className="bg-primary mt-4 mb-2 px-6 py-4 mx-auto max-w-lg rounded-lg">
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    name="agreedToTerms"
                    checked={formData.agreedToTerms}
                    onChange={handleInputChange}
                    className="text-primary focus:ring focus:ring-primary"
                  />
                  <span className="text-[10px] text-black">
                    I agree to Futcoinspot’s terms and conditions and privacy policy.
                  </span>
                </label>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className={`w-full bg-primary text-black font-bold px-8 py-3 rounded-lg transition mt-1 ${!formData.agreedToTerms || loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "hover:bg-yellow-300"
                  }`}
                disabled={!formData.agreedToTerms || loading}
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <svg
                      className="animate-spin h-5 w-5 mr-2 text-black"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                    Processing...
                  </span>
                ) : (
                  "Sell"
                )}
              </button>

            </form>


            {/* Form */}

          </div>



          {/* Right Section */}
          <div className="hidden md:block bg-[#1A1A1A] border border-gray-600 rounded-lg p-6 text-center">
            {/* How It Works Section */}
            <div className="mb-8">
              <img src={bulb} alt="How It Works" className="w-10 h-10 mx-auto mb-4" />
              <h3 className="text-primary text-lg font-bold mb-4">How It Works?</h3>
              <ul className="text-sm text-white space-y-2 text-left">
                <li>1. Fill out the form, and we’ll take care of everything else.</li>
                <li>2. The coin selling and payment process usually takes 24 hours.</li>
                <li>3. Stay offline on your console and apps during this process.</li>
                <li>4. Payment is sent within 24 hours after the coins are transferred.</li>
              </ul>
            </div>

            {/* Requirements Section */}
            <div>
              <img src={req} alt="Requirements" className="w-10 h-10 mx-auto mb-4" />
              <h3 className="text-primary text-lg font-bold mb-4">Requirements</h3>
              <ul className="text-sm text-white space-y-2 text-left">
                <li>• Web App Transfer Market must be unlocked.</li>
                <li>• Minimum of 500k (500,000) coins.</li>
                <li>• Fewer than 5 unassigned items.</li>
                <li>• Must stay offline on console, web app, and companion app.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

    </>
    // <>
    //   <div className="flex items-center justify-center h-screen">
    //     <div className="bg-black text-red text-center w-full  flex items-center justify-center rounded-lg shadow-lg">
    //       <span className="text-lg text-white font-inter font-bold">We are currently not buying</span>
    //     </div>
    //   </div>

    // </>
  );
};

export default SellCoins;
